(function() {
  'use strict';
  
  angular
    .module('plugins.word-cloud')
    .controller('WordCloudResultShownController', WordCloudResultShownController);
  
  WordCloudResultShownController.$inject = [
    '$log', 
    '$scope',
    '$interval',
    'pollPluginService'
  ];
    
  function WordCloudResultShownController(
      $log, 
      $scope,
      $interval,
      pollPluginService
    ) {
    $log = $log.getInstance('WordCloudResultShownController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.poll = null;
    vm.responsesByUser = null;
    vm.result = null;
    vm.numberOfResponses = 0;
    vm.words = {};
    vm.wordsUpdated = false;
    
    activate();
    
    function activate() {
      var poll = vm.poll = $scope.poll
        , result = vm.result = $scope.result;
      
      if (!angular.isObject(result.data))
        result.data = {}; 
      
      if (!result.data.hasOwnProperty('word-cloud')) {
        result.data['word-cloud'] = [];
      }
      
      // Calculate aggregates for existing responses
      // vm.responsesByUser = _.groupBy(result.responses, 'user');
      // _.each(vm.responsesByUser, function(userResponses) {
      //   var lastResponse = _.last(userResponses).data;
      //   _addWord(lastResponse);
      // });

      _.each(result.responses, function(response) {
        _addWord(response.data);
      });
      
      pollPluginService.onResponseReceived($scope, result._id, _onResponseReceived);
    }
    
    function _onResponseReceived(response) {
      $scope.result.responses.push(response)
      $log.info('response = ', response);
      // if (_.has(vm.responsesByUser, response.user)) {
        // var lastResponse = _.last(vm.responsesByUser[response.user]).data;
        // _removeWord(lastResponse);
      // }
      // else {
        // vm.responsesByUser[response.user] = [];
      // }
      // vm.responsesByUser[response.user].push(response);
      _addWord(response.data);
    }
    
    function _addWord(word) {
      vm.numberOfResponses++
      var filtered = _filterWord(word);
      if (angular.isObject(vm.words[filtered]))
        vm.words[filtered].frequency++;
      else {
        vm.words[filtered] = { text: filtered, frequency: 1 };
        vm.result.data['word-cloud'] = _.values(vm.words);
      }
    }

    function _filterWord(word) {
      return word
        .split(' ')[0]
        .toLowerCase()
        .substring(0, 24);
    }
    
    function _removeWord(word) {
      if (!angular.isObject(vm.words[word]))
        return;
      if (vm.words[word].frequency > 1)
        vm.words[word].frequency--;
      else {
        delete vm.words[word];
        vm.result.data['word-cloud'] = _.values(vm.words);
      }
    }

  }
  
})();